var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1293 9.76175L8.88685 3.33639C8.78432 3.2298 8.66234 3.1452 8.52794 3.08746C8.39354 3.02973 8.24938 3 8.10378 3C7.95819 3 7.81403 3.02973 7.67963 3.08746C7.54523 3.1452 7.42325 3.2298 7.32072 3.33639C7.1153 3.54947 7 3.8377 7 4.13814C7 4.43858 7.1153 4.72681 7.32072 4.93989L12.7801 10.626L7.32072 16.2553C7.1153 16.4684 7 16.7566 7 17.0571C7 17.3575 7.1153 17.6458 7.32072 17.8588C7.42286 17.9663 7.54467 18.0518 7.67909 18.1103C7.81351 18.1689 7.95786 18.1994 8.10378 18.2C8.24971 18.1994 8.39406 18.1689 8.52848 18.1103C8.66289 18.0518 8.7847 17.9663 8.88685 17.8588L15.1293 11.4335C15.2413 11.327 15.3306 11.1977 15.3917 11.0539C15.4528 10.91 15.4844 10.7547 15.4844 10.5976C15.4844 10.4406 15.4528 10.2852 15.3917 10.1413C15.3306 9.99749 15.2413 9.86824 15.1293 9.76175Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.ace6c1da0be04932d465ba04b51d1e41.svg";
export { ForwardRef as ReactComponent };